export default {"socialButton":"-aZet"};